import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/map.svg'
import _imports_1 from '@/assets/images/usa.svg'
import _imports_2 from '@/assets/images/canada.svg'
import _imports_3 from '@/assets/images/brazil.svg'


const _hoisted_1 = { class: "card custom-shadow rounded-3 bg-white border mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "custom-padding-30" }, [
      _createElementVNode("div", { class: "d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-4" }, [
        _createElementVNode("h3", { class: "mb-0 fw-semibold" }, "Call Center Geography"),
        _createElementVNode("div", {
          class: "dropdown select-dropdown without-border position-relative",
          style: {"right":"-5px"}
        }, [
          _createElementVNode("button", {
            class: "dropdown-toggle bg-transparent border text-body rounded-2",
            style: {"padding-right":"20px"},
            role: "button",
            "data-bs-toggle": "dropdown",
            "aria-expanded": "false"
          }, " Last Year "),
          _createElementVNode("ul", { class: "dropdown-menu dropdown-menu-end bg-white border-0 box-shadow py-3" }, [
            _createElementVNode("li", null, [
              _createElementVNode("button", { class: "dropdown-item text-secondary py-2 px-3" }, " Today ")
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", { class: "dropdown-item text-secondary py-2 px-3" }, " Last Week ")
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", { class: "dropdown-item text-secondary py-2 px-3" }, " Last Month ")
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", { class: "dropdown-item text-secondary py-2 px-3" }, " Last Year ")
            ])
          ])
        ])
      ]),
      _createElementVNode("div", {
        class: "text-center",
        style: {"margin":"40px 0"}
      }, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "map",
          style: {"height":"187px"}
        })
      ]),
      _createElementVNode("ul", { class: "ps-0 mb-0 list-unstyled sales_by_locations mt-4" }, [
        _createElementVNode("li", { class: "d-flex align-items-center pe-0" }, [
          _createElementVNode("div", { class: "flex-shrink-0" }, [
            _createElementVNode("img", {
              src: _imports_1,
              class: "wh-30 rounded-circle",
              alt: "usa"
            })
          ]),
          _createElementVNode("div", { class: "flex-grow-1 ms-3" }, [
            _createElementVNode("div", { class: "d-flex justify-content-between position-relative" }, [
              _createElementVNode("span", { class: "fw-medium d-block mb-2" }, "United States"),
              _createElementVNode("span", { class: "count fw-medium text-body" }, "90%"),
              _createElementVNode("span", { class: "position-absolute top-50 start-50 translate-middle pb-2 fw-medium" }, "1,200 calls")
            ]),
            _createElementVNode("div", {
              class: "progress",
              role: "progressbar",
              "aria-label": "Example with label",
              "aria-valuenow": "90",
              "aria-valuemin": "0",
              "aria-valuemax": "100"
            }, [
              _createElementVNode("div", {
                class: "progress-bar bg-success-60",
                style: {"width":"90%"}
              })
            ])
          ])
        ]),
        _createElementVNode("li", { class: "d-flex align-items-center pe-0" }, [
          _createElementVNode("div", { class: "flex-shrink-0" }, [
            _createElementVNode("img", {
              src: _imports_2,
              class: "wh-30 rounded-circle",
              alt: "canada"
            })
          ]),
          _createElementVNode("div", { class: "flex-grow-1 ms-3" }, [
            _createElementVNode("div", { class: "d-flex justify-content-between position-relative" }, [
              _createElementVNode("span", { class: "fw-medium d-block mb-2" }, "Canada"),
              _createElementVNode("span", { class: "count fw-medium text-body" }, "88%"),
              _createElementVNode("span", { class: "position-absolute top-50 start-50 translate-middle pb-2 fw-medium" }, "980 calls")
            ]),
            _createElementVNode("div", {
              class: "progress",
              role: "progressbar",
              "aria-label": "Example with label",
              "aria-valuenow": "88",
              "aria-valuemin": "0",
              "aria-valuemax": "100"
            }, [
              _createElementVNode("div", {
                class: "progress-bar bg-primary",
                style: {"width":"88%"}
              })
            ])
          ])
        ]),
        _createElementVNode("li", { class: "d-flex align-items-center pe-0" }, [
          _createElementVNode("div", { class: "flex-shrink-0" }, [
            _createElementVNode("img", {
              src: _imports_3,
              class: "wh-30 rounded-circle",
              alt: "brazil"
            })
          ]),
          _createElementVNode("div", { class: "flex-grow-1 ms-3" }, [
            _createElementVNode("div", { class: "d-flex justify-content-between position-relative" }, [
              _createElementVNode("span", { class: "fw-medium d-block mb-2" }, "Brazil"),
              _createElementVNode("span", { class: "count fw-medium text-body" }, "65%"),
              _createElementVNode("span", { class: "position-absolute top-50 start-50 translate-middle pb-2 fw-medium" }, "850 calls")
            ]),
            _createElementVNode("div", {
              class: "progress",
              role: "progressbar",
              "aria-label": "Example with label",
              "aria-valuenow": "65",
              "aria-valuemin": "0",
              "aria-valuemax": "100"
            }, [
              _createElementVNode("div", {
                class: "progress-bar bg-danger",
                style: {"width":"65%"}
              })
            ])
          ])
        ])
      ])
    ], -1)
  ]))]))
}